import app from "./app.mjs";

app();